import { Navigate } from '@tanstack/react-location';
import React from 'react';
import { useFlexAssessmentContext } from '../context/context';
import { PAGE_URLS } from '../utils/constants';

export default function SignupGatedContainer(props: {
  children: React.ReactNode;
}): JSX.Element {
  const { state } = useFlexAssessmentContext();

  if (!state.accessCodeConfig?.accessCode) {
    return <Navigate to={PAGE_URLS.ERROR} />;
  } else {
    window.scrollTo(0, 0);
    return props.children as JSX.Element;
  }
}
